import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import useFetch from 'use-http';
import { computeGoalStep, getGoalComponent, GOAL_FLOW } from './compute_goals_container';

const GoalsFlow = () => {
  const [currentStep, setCurrentStep] = useState('type');
  const [goalData, setGoalData] = useState({});

  const { post } = useFetch();
  const history = useHistory();

  const handleStepComplete = (data) => {
    setGoalData({ ...goalData, ...data });
    const nextStep = computeGoalStep(currentStep);
    setCurrentStep(nextStep);
  };

  const handleBack = () => {
    const currentIndex = GOAL_FLOW.STEPS.indexOf(currentStep);
    if (currentIndex <= 0) {
      history.goBack();
    } else {
      setCurrentStep(GOAL_FLOW.STEPS[currentIndex - 1]);
    }
  };

  const handleFinalSubmit = async (data) => {
    try {
      await post('/goals', data);
      history.replace('/tabs/goals');
    } catch (error) {
      console.error('Error submitting goal', error);
    }
  };

  const CurrentComponent = getGoalComponent(currentStep);

  return CurrentComponent ? (
    <CurrentComponent
      onComplete={handleStepComplete}
      goalData={goalData}
      onBack={handleBack}
      onFinalSubmit={handleFinalSubmit}
    />
  ) : null;
};

export default GoalsFlow;
